
import React from 'react';

const LoginDivider: React.FC<{ text?: string }> = ({ text = "Or continue with" }) => {
  return (
    <div className="relative mt-6">
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-hormony-beige/50"></div>
      </div>
      <div className="relative flex justify-center text-sm">
        <span className="px-2 bg-white text-hormony-charcoal/70">
          {text}
        </span>
      </div>
    </div>
  );
};

export default LoginDivider;
